import { Box, LoadingOverlay } from '@mantine/core';
import { getCreditNoteFormValues, InvoiceForm } from 'modules/Invoices/InvoiceForm';
import type { RouteComponentProps } from 'react-router';
import { useHistory } from 'react-router';
import { isDefined } from 'remeda';
import { useCreateCreditNote } from 'shared/hooks/use-create-credit-note';
import { useLoadCreditNote } from 'shared/hooks/use-load-credit-note';
import { useUpdateCreditNote } from 'shared/hooks/use-update-credit-note';
import { isDraft } from 'shared/utils/invoice-status';

export default function ManageCreditNote({
  match: { params },
}: RouteComponentProps<{ id?: string }>) {
  const history = useHistory();

  const { createCreditNote } = useCreateCreditNote({
    onSuccess: response => {
      const newCreditNote = response.data.data;
      history.push(newCreditNote ? `/credit-notes/draft/${newCreditNote.id}` : '/credit-notes');
    },
  });

  const { updateCreditNote } = useUpdateCreditNote({
    onSuccess: (response, variables) => {
      if (isDraft(response.data.data.attributes)) {
        history.push(`/credit-notes/draft/${variables.id}`);
      }
    },
  });

  const creditNoteId = params.id ? Number(params.id) : undefined;
  const { creditNote } = useLoadCreditNote(creditNoteId);

  const isEditMode = isDefined(creditNoteId);

  if (isEditMode && !isDefined(creditNote)) {
    return (
      <Box h="100%" pos="relative">
        <LoadingOverlay visible />
      </Box>
    );
  }

  if (isEditMode && isDefined(creditNote)) {
    return (
      <InvoiceForm
        initialValues={getCreditNoteFormValues(creditNote)}
        creditNote={creditNote}
        isCreditNote
        submit={data => updateCreditNote({ id: creditNote.id, data })}
      />
    );
  }

  return <InvoiceForm isCreditNote submit={data => createCreditNote({ data })} />;
}
